// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-card {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.invoice-card .invoice-title {
  flex-wrap: wrap;
  align-items: center;
}
.invoice-card .invoice-infos,
.invoice-card .invoice-title {
  display: flex;
}
.invoice-card .invoice-infos .invoice-title-container,
.invoice-card .invoice-title .invoice-title-container {
  margin-right: 0.4rem;
}
.invoice-card .invoice-infos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.invoice-card .invoice-infos .left-side {
  display: flex;
}
@media (min-width: calc(768px + 1px)) {
  .invoice-card .invoice-infos .left-side .gyramais-information + .gyramais-information {
    margin-left: 4rem;
  }
}
@media (max-width: 768px) {
  .invoice-card .invoice-infos .left-side {
    flex-direction: column;
  }
}
.invoice-card .invoice-infos .clock {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--danger-color);
}
.invoice-card .invoice-infos .clock span {
  color: var(--danger-color);
  font-size: 2rem;
  font-weight: 500;
}
.invoice-card .invoice-infos .clock .anticon {
  margin-bottom: 0.188rem;
  margin-right: 0.5rem;
  font-size: 1.2rem;
}
.invoice-card .invoice-infos .clock .ant-statistic-content-value {
  line-height: 2rem;
}
@media (max-width: 768px) {
  .invoice-card .invoice-infos {
    align-items: flex-start;
  }
}
@media (max-width: 768px) {
  .invoice-card .invoice-infos {
    flex-direction: column;
    height: 100%;
  }
  .invoice-card .invoice-infos .invoice-infos-value,
  .invoice-card .invoice-infos .invoice-infos-dueDate,
  .invoice-card .invoice-infos .invoice-infos-timer {
    margin-bottom: 0.65rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/screens/PromoRenegotiationScreen/Components/PromoRenegotiatedInvoice.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AACF;AAJA;EAMI,eAAA;EACA,mBAAA;AACJ;AARA;;EAWI,aAAA;AACJ;AAZA;;EAcM,oBAAA;AAEN;AAhBA;EAmBI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;AAAJ;AAtBA;EAyBM,aAAA;AAAN;AAEM;EAAA;IAEI,iBAAA;EAAR;AACF;AAGM;EAAA;IACE,sBAAA;EAAN;AACF;AAnCA;EAuCM,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;AADN;AAzCA;EA6CQ,0BAAA;EACA,eAAA;EACA,gBAAA;AADR;AA9CA;EAmDQ,uBAAA;EACA,oBAAA;EACA,iBAAA;AAFR;AAnDA;EAyDQ,iBAAA;AAHR;AAOI;EAAA;IACE,uBAAA;EAJJ;AACF;AAOE;EAAA;IAEI,sBAAA;IACA,YAAA;EALJ;EAEA;;;IAMM,sBAAA;EAHN;AACF","sourcesContent":[".invoice-card {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  \n  .invoice-title {\n    flex-wrap: wrap;\n    align-items: center;\n  }\n\n  .invoice-infos, .invoice-title {\n    display: flex;\n\n    .invoice-title-container {\n      margin-right: .4rem;\n    }\n  }\n\n  .invoice-infos {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n\n    .left-side {\n      display: flex;\n\n      @media(min-width: calc(@md-screen + 1px)) {\n        .gyramais-information + .gyramais-information {\n          margin-left: 4rem;\n        }\n      }\n\n      @media(max-width: @md-screen) {\n        flex-direction: column;\n      }\n    }\n\n    .clock {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      color: var(--danger-color);\n\n      span {\n        color: var(--danger-color);\n        font-size: 2rem;\n        font-weight: 500;\n      }\n      \n      .anticon {\n        margin-bottom: .188rem;\n        margin-right: 0.5rem;\n        font-size: 1.2rem;\n      }\n\n      .ant-statistic-content-value {\n        line-height: 2rem;\n      }\n    }\n\n    @media(max-width: @md-screen) {\n      align-items: flex-start;\n    }\n  }\n\n  @media(max-width: @md-screen) {\n    .invoice-infos {\n      flex-direction: column;\n      height: 100%;\n\n      .invoice-infos-value, .invoice-infos-dueDate, .invoice-infos-timer {\n        margin-bottom: 0.65rem;\n      }\n    }\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
